import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApiMemberKnowledgeInsightPostCommentsShowResponseType } from "~/domains";

type ParamsType = {
  id: string;
};

const request = async ({
  id,
}: ParamsType): Promise<ApiMemberKnowledgeInsightPostCommentsShowResponseType> => {
  const response =
    await new ApiClient().get<ApiMemberKnowledgeInsightPostCommentsShowResponseType>(
      `/api/members/knowledge_insight_post_comments/${id}`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersKnowledgeInsightPostCommentsShow = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiMemberKnowledgeInsightPostCommentsShowResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisMembersKnowledgeInsightPostCommentsShow", id],
    queryFn: () => request({ id }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
